import React, { FC } from 'react'
import { Divider, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

/**
 * Visual connector between configuration cards.
 *
 * Vespa configurations are independent parallel scorers, not a sequential
 * fallback waterfall (unlike BlueConic) — every configuration scores the
 * entire eligible pool simultaneously, and the reader gets whichever
 * article scores highest across all of them. The connector must not imply
 * ordering ("if this fails, try the next one"); it reflects that the
 * configurations are additive/parallel instead.
 */
export const VespaConfigConnector: FC = () => {
    return (
        <Divider
            plain
            style={{
                margin: 'unset',
                paddingInlineStart: '25%',
                paddingInlineEnd: '25%',
            }}
        >
            <Typography.Text
                type="secondary"
                style={{
                    fontSize: 'var(--font-size-s)',
                    fontWeight: 600,
                }}
            >
                <PlusOutlined aria-hidden="true" style={{ marginInlineEnd: 'var(--space-1)' }} />
                Also scored in parallel
            </Typography.Text>
        </Divider>
    )
}
